<template>
  <m-dialog
    v-model="isDialogOpen"
    class="go-dialog"
    v-bind="$attrs"
    v-on="$listeners">
    <div
      v-if="header"
      slot="header">
      {{ header }}
    </div>
    <div
      v-if="body"
      slot="body"
      :level="1">
      {{ body }}
    </div>

    <!-- vue material components library quirk: cancelButton slot is always first button -->
    <m-button
      v-if="actionButton"
      slot="acceptButton"
      class="raise-button action-button mdc-dialog__button"
      data-mdc-dialog-action="action"
      raised>
      {{ actionButton }}
    </m-button>
    <m-button
      v-if="cancelButton"
      slot="cancelButton"
      class="cancel-button mdc-dialog__button"
      data-mdc-dialog-action="cancel">
      {{ cancelButton }}
    </m-button>
    <m-button
      v-if="unraisedActionButton"
      slot="dialogButton"
      class="action-button mdc-dialog__button"
      data-mdc-dialog-action="unraised-action">
      {{ unraisedActionButton }}
    </m-button>
  </m-dialog>
</template>
<script>

import Vue from 'vue'
import MButton from 'material-components-vue/dist/button'
import Dialog from 'material-components-vue/dist/dialog'

Vue.use(MButton)
Vue.use(Dialog)

export default {
  props: {
    actionButton: {
      default: '',
      required: false,
      type: String
    },
    body: {
      default: '',
      required: false,
      type: String
    },
    cancelButton: {
      default: '',
      required: false,
      type: String
    },
    unraisedActionButton: {
      default: '',
      required: false,
      type: String
    },
    header: {
      default: '',
      required: false,
      type: String
    },
    raiseAction: {
      default: false,
      required: false,
      type: Boolean
    },
    value: {
      required: true,
      type: Boolean
    }
  },
  data () {
    return {
      isDialogOpen: this.value
    }
  },
  watch: {
    value () {
      this.isDialogOpen = this.value
    }
  }
}
</script>
<style lang="scss" scoped>
  @import '../../universal/vars.scss';
  @import "material-components-vue/dist/dialog/styles";

  .mdc-dialog {
    z-index: 30;
  }

  /deep/ .mdc-dialog__title {
    line-height: 0;
    margin-bottom: 28px;
    margin-top: -4px;

    // h5 roboto bold
    font-weight: bold;
    font-size: 18px;
    letter-spacing: 0.25px;
  }
  /deep/ .mdc-dialog__container .mdc-dialog__surface .mdc-dialog__content {
    color: $black-high-emphasis;

    // Body 2 / Roboto Regular
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.25px;
  }

  .go-dialog button[data-mdc-dialog-action="cancel"]:not(:disabled) {
    color: $mdc-theme-primary;
  }
  .go-dialog .mdc-button {
    text-transform: none;
  }
  /deep/ .mdc-dialog__actions {
    padding: 8px 24px 16px 24px;
  }
  .go-dialog .mdc-button:not(.mdc-ripple-upgraded):focus::before {
    opacity: 0;
  }
  .go-dialog .mdc-button.mdc-ripple-upgraded--background-focused::before {
    opacity: 0;
  }
  .go-dialog .mdc-button.mdc-ripple-upgraded--background-focused:hover {
    background-color: rgb(241, 248, 249);
  }
  .go-dialog .action-button {
    min-width: 116px;
  }
  .go-dialog .cancel-button {
    min-width: 88px;
  }
  .go-dialog .mdc-dialog__actions .raise-button {
    background-color: $mdc-theme-primary;
    color: white;
  }
  .go-dialog .mdc-dialog__actions .raise-button.mdc-ripple-upgraded--background-focused:hover,
  .go-dialog .mdc-dialog__actions .raise-button:hover {
    background-color: $mdc-theme-primary !important; // overrides inline style
  }
</style>
